/* tslint:disable */
/* eslint-disable */
/**
 * Legalscape REST API
 * Internal API for use from web
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { HandleShopifyWebhookParamsBody } from '../model';
/**
 * ShopifyApi - axios parameter creator
 * @export
 */
export const ShopifyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Shopify Webhook用エンドポイント(ユーザが購入した書籍を読めるよう登録)
         * @param {HandleShopifyWebhookParamsBody} [handleShopifyWebhookParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleShopifyWebhook: async (handleShopifyWebhookParamsBody?: HandleShopifyWebhookParamsBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/shopify/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(handleShopifyWebhookParamsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopifyApi - functional programming interface
 * @export
 */
export const ShopifyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShopifyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Shopify Webhook用エンドポイント(ユーザが購入した書籍を読めるよう登録)
         * @param {HandleShopifyWebhookParamsBody} [handleShopifyWebhookParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleShopifyWebhook(handleShopifyWebhookParamsBody?: HandleShopifyWebhookParamsBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleShopifyWebhook(handleShopifyWebhookParamsBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShopifyApi - factory interface
 * @export
 */
export const ShopifyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShopifyApiFp(configuration)
    return {
        /**
         * 
         * @summary Shopify Webhook用エンドポイント(ユーザが購入した書籍を読めるよう登録)
         * @param {HandleShopifyWebhookParamsBody} [handleShopifyWebhookParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleShopifyWebhook(handleShopifyWebhookParamsBody?: HandleShopifyWebhookParamsBody, options?: any): AxiosPromise<void> {
            return localVarFp.handleShopifyWebhook(handleShopifyWebhookParamsBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShopifyApi - interface
 * @export
 * @interface ShopifyApi
 */
export interface ShopifyApiInterface {
    /**
     * 
     * @summary Shopify Webhook用エンドポイント(ユーザが購入した書籍を読めるよう登録)
     * @param {HandleShopifyWebhookParamsBody} [handleShopifyWebhookParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyApiInterface
     */
    handleShopifyWebhook(handleShopifyWebhookParamsBody?: HandleShopifyWebhookParamsBody, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ShopifyApi - object-oriented interface
 * @export
 * @class ShopifyApi
 * @extends {BaseAPI}
 */
export class ShopifyApi extends BaseAPI implements ShopifyApiInterface {
    /**
     * 
     * @summary Shopify Webhook用エンドポイント(ユーザが購入した書籍を読めるよう登録)
     * @param {HandleShopifyWebhookParamsBody} [handleShopifyWebhookParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyApi
     */
    public handleShopifyWebhook(handleShopifyWebhookParamsBody?: HandleShopifyWebhookParamsBody, options?: AxiosRequestConfig) {
        return ShopifyApiFp(this.configuration).handleShopifyWebhook(handleShopifyWebhookParamsBody, options).then((request) => request(this.axios, this.basePath));
    }
}
